import { initializeApp } from 'firebase/app';
import {
  getAuth, GoogleAuthProvider, signInWithPopup, signOut,
  onAuthStateChanged, setPersistence, browserLocalPersistence,
} from 'firebase/auth';

// Firebase Hosting auto-serves the web app config at this path. No build-time
// secrets required — the Terraform links the hosting site to the web app, and
// Firebase populates this endpoint.
async function loadConfig() {
  const res = await fetch('/__/firebase/init.json');
  if (!res.ok) throw new Error('firebase config not reachable');
  return res.json();
}

let appPromise;
export function getApp() {
  if (!appPromise) appPromise = loadConfig().then(initializeApp);
  return appPromise;
}

export async function getAuthOrInit() {
  const app = await getApp();
  const auth = getAuth(app);
  await setPersistence(auth, browserLocalPersistence);
  return auth;
}

export async function signInWithGoogle() {
  const auth = await getAuthOrInit();
  await signInWithPopup(auth, new GoogleAuthProvider());
}

export async function signOutUser() {
  const auth = await getAuthOrInit();
  await signOut(auth);
}

export async function observeAuth(cb) {
  const auth = await getAuthOrInit();
  return onAuthStateChanged(auth, cb);
}

export async function getIdToken() {
  const auth = await getAuthOrInit();
  const u = auth.currentUser;
  if (!u) return null;
  return u.getIdToken();
}
